module.exports = __webpack_public_path__ + "img/English Sharp Shooter Locked.8996c50.png";